import { Input } from "@/components/Input"
import { ProfileLinkProps } from "@/types"

type EditProfileLinksProps = {
  links: ProfileLinkProps
  linkError: { link: string; error: string }
}

const EditProfileLinks = ({ links, linkError }: EditProfileLinksProps) => {
  return (
    <>
      {Object.keys(links).map((key) => {
        return (
          <Input
            key={key}
            type="text"
            name={key}
            labelError={linkError.link === key ? linkError.error : ""}
            label={`${key.charAt(0).toUpperCase() + key.slice(1)} username`}
            placeholder={`Your ${key} username`}
            defaultValue={links[key as keyof ProfileLinkProps]}
            className="bg-zinc-900 w-full mb-2"
          />
        )
      })}
    </>
  )
}

export default EditProfileLinks
